<div class="scroll-area px-2">
  <div class="mb-3 mt-3">
    <label class="form-label text-xs fw-bold">Select Sub-section</label>
    <select v-model="section_id" class="form-select text-xxs rounded-3 shadow-sm" id="section_id">
      <option value="" disabled hidden>Select Type</option>
      <option v-for="type in section_list" :key="type.id" :value="type.section_id">
        {{ type.section_name }}
      </option>
    </select>
  </div>

  <div v-for="(form, index) in question_forms" :key="index">
    <div class="d-flex flex-row align-items-center justify-content-end">
      <div class="d-flex align-items-center">
        <span class="text-xs me-2 fw-bold">Create Question</span>
        <div class="d-flex">
          <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow me-2" @click="add_question_form">
            Add
          </button>
          <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow me-2"
            @click="remove_question_form(index)" :disabled="question_forms.length === 1">
            Remove
          </button>
        </div>
      </div>
      <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow"
        @click="add_dependent_question(form)" v-if="form.question_type_id && is_select_type(form.question_type_id)">
        Add Dependent Questions
      </button>
    </div>

    <div class="card-body mt-2">
      <form @submit.prevent>
        <div class="row mt-2 mb-3">
          <div class="col">
            <label class="form-label text-xs">
              <small>Question {{ index + 1 }}</small>
            </label>
            <input v-model="form.question_text" type="text" class="form-control text-xxs rounded-small shadow-sm"
              placeholder="e.g Are you a director of a company?">
          </div>
          <div class="col">
            <label class="form-label text-xs">
              <small>Question Number</small>
            </label>
            <input v-model="form.question_number" type="text" class="form-control text-xxs rounded-small shadow-sm"
              placeholder="eg. 1">
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <label class="form-label text-xs">
              <small>Question Type</small>
            </label>
            <select v-model="form.question_type_id" class="form-select text-xxs rounded-small shadow-sm"
              @change="handle_question_type_change(form)">
              <option value="" disabled hidden>Select Type</option>
              <option v-for="type in question_types" :key="type.id" :value="type.id">
                {{ type.formatted_type }}
              </option>
            </select>
          </div>
          
          <div class="col">
            <label class="form-label text-xs"><small>Is question mandatory?</small></label>
            <select v-model="form.mandatory" class="form-select text-xxs rounded-small shadow-sm">
              <option value="" disabled hidden>Select Option</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
        </div>

        <!-- Options for Select Types -->
        <div v-if="form.show_option_inputs" class="mt-3">
          <div class="row mb-2">
            <div class="col-12 d-flex justify-content-between align-items-center">
              <label class="form-label text-xs mb-0"><small>Options</small></label>
              <div>
                <button type="button" @click="add_option_input(form)"
                  class="btn btn-primary-dark btn-sm rounded-small fw-bold text-xxs shadow text-white me-2">
                  <i class="fas fa-plus"></i>
                </button>
                <button type="button" v-if="form.option_inputs.length > 2" @click="remove_option_input(index, form)"
                  class="btn btn-primary-dark btn-sm rounded-small fw-bold text-xxs shadow text-white">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </div>

          <div v-for="(option, option_index) in form.option_inputs" :key="option_index" class="row mb-3">
            <div class="col-12">
              <input v-model.lazy="form.option_inputs[option_index]" type="text"
                class="form-control text-xs rounded-small p-2 shadow-sm" :placeholder="'Option ' + (option_index + 1)"/>
            </div>
          </div>
        </div>

        <div class="mt-4 border-top pt-3">
          <div v-if="form.dependant_questions && form.dependant_questions.length > 0">
            <div v-for="(dep_question, dep_index) in form.dependant_questions" :key="dep_index"
              class="mb-4 p-3 border rounded">
              <div class="d-flex justify-content-between mb-2">
                <h6 class="mb-0 text-xs">Dependent Question {{ dep_index + 1 }}</h6>
                <div>
                  <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow"
                    @click="remove_dependent_question(form, dep_index)">
                    Remove
                  </button>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="form-label text-xs">Question Text<span class="text-danger fs-6">*</span></label>
                  <input v-model="dep_question.question_text" type="text"
                    class="form-control text-xxs rounded-small shadow-sm"
                    placeholder="e.g. Which framework do you use?">
                </div>
                <div class="col-md-6">
                  <label class="form-label text-xs">Trigger Condition<span class="text-danger fs-6">*</span></label>
                  <select v-model="dep_question.trigger_condition" class="form-select text-xxs rounded-small shadow-sm"
                    v-if="form.option_inputs && form.option_inputs.length > 0">
                    <option value="" disabled hidden>Select Condition</option>
                    <option v-for="option in form.option_inputs" :key="option" :value="option">
                      {{ option }}
                    </option>
                  </select>
                  <input v-else v-model="dep_question.trigger_condition" type="text"
                    class="form-control text-xxs rounded-small shadow-sm" placeholder="e.g. Python">
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-4">
                  <label class="form-label text-xs">Question Type<span class="text-danger fs-6">*</span></label>
                  <select v-model="dep_question.question_type_id" class="form-select text-xxs rounded-small shadow-sm"
                    @change="handle_dependent_question_type_change(dep_question)">
                    <option value="" disabled hidden>Select Type</option>
                    <option v-for="type in question_types" :key="type.id" :value="type.id">
                      {{ type.formatted_type }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label text-xs">Question Number</label>
                  <input v-model="dep_question.question_number" type="text"
                    class="form-control text-xxs rounded-small shadow-sm" placeholder="e.g. 1.1">
                </div>
                <div class="col-md-4">
                  <label class="form-label text-xs">Is question mandatory?</label>
                  <select v-model="dep_question.is_mandatory" class="form-select text-xxs rounded-small shadow-sm">
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>
              </div>


              <div v-if="dep_question.show_option_inputs" class="mt-3">
                <div class="row mb-2">
                  <div class="col-12 d-flex justify-content-between align-items-center">
                    <label class="form-label text-xs mb-0">Options</label>
                    <div>
                      <button type="button" @click="add_dependent_option(dep_question)"
                        class="btn btn-primary-dark btn-sm rounded-small fw-bold text-xxs shadow text-white me-2">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div v-for="(option, option_index) in dep_question.options" :key="option_index" class="row mb-3">
                  <div class="col-10">
                    <input v-model="option.choice" type="text" class="form-control text-xs rounded-small p-2 shadow-sm"
                      placeholder="Option value">
                  </div>
                  <div class="col-2">
                    <button type="button" @click="remove_dependent_option(dep_question, option_index)"
                      class="btn btn-danger btn-sm rounded-small fw-bold text-xxs shadow">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-center py-4 text-muted">
            <p class="text-xs mb-0">No dependent questions added yet</p>
          </div>
        </div>

        <div class="col text-end d-none">
          <button type="submit" class="btn btn-primary-dark btn-sm text-xxs rounded-small mt-3 shadow-sm">
            Create Question
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="text-end">
    <button 
      class="btn btn-primary-dark btn-sm text-xxs rounded-small shadow-sm"
      @click="save_all_questions"
    >
      Save All Questions
    </button>
  </div>

</div>